import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Login successful');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="font-heading text-3xl text-[#2C2C2C] mb-2" data-testid="login-title">
            Admin Login
          </h1>
          <p className="font-body text-[#767C91]">
            The Lady Hustler Society Club
          </p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white border border-[#E2E8F0] p-8 space-y-6">
          <div>
            <label className="font-label text-xs text-[#767C91] tracking-widest block mb-2">
              EMAIL
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@ladyhustler.com"
              className="rounded-none border-[#E2E8F0] focus:border-[#9D6E6D]"
              required
              data-testid="login-email"
            />
          </div>

          <div>
            <label className="font-label text-xs text-[#767C91] tracking-widest block mb-2">
              PASSWORD
            </label>
            <div className="relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="rounded-none border-[#E2E8F0] focus:border-[#9D6E6D] pr-10"
                required
                data-testid="login-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#767C91] hover:text-[#2C2C2C]"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#9D6E6D] hover:bg-[#2C2C2C] text-white font-label text-xs tracking-widest rounded-none py-6"
            data-testid="login-submit"
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>

        <p className="text-center mt-6 text-sm text-[#767C91]">
          <a href="/en/blog" className="hover:text-[#9D6E6D]">← Back to Blog</a>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
